import catalogContexts from "@utils/constants/catalogContexts";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function initializeUiStateForHub(uiState, context) {
  uiState[mainIndex].refinementList.catalogs = [];

  switch (context) {
    case catalogContexts.swap:
      uiState[mainIndex].refinementList.catalogs = ["In Swap"];
      break;
    case catalogContexts.sales:
      uiState[mainIndex].refinementList.catalogs = ["In Sales"];
      break;
    default:
      uiState[mainIndex].refinementList.catalogs = ["In Swap", "In Sales"];
  }

  const initialStock = context === catalogContexts.userlist ? ["false", "true"] : ["true"];
  uiState[mainIndex].refinementList.in_stock = initialStock;

  for (let [key, value] of Object.entries(uiState[mainIndex].refinementList)) {
    if (!value || value?.length === 0) delete uiState[mainIndex].refinementList[key];
  }

  return uiState;
}
